const en = {
    edit_profile: 'Edit profile',
    handle_cv: 'CV management',
    competence_title: 'Want to enhance your skills?',
    competence_subtitle: 'Sign up for our advanced courses',
    competence_button: 'Discover our courses',
    knowledge_title: 'Want to broaden your knowledge?',
    knowledge_subtitle: 'Join our Telegram channel',
    knowledge_button: 'Discover our webinars',
    choose_hobby: 'Enter one of your hobbies',
    profile_photo: 'Profile photo',
    video_cv: 'Video CV',
    about_me: 'Something about me',
    other: 'Other',
    languages: 'Languages',
    hobby: 'Hobby',
    social: 'Social',
    link: 'Link',
    certificates: 'Certificates',
    certifications: 'Certifications',
    questionnaires: 'Questionnaires',
    insert_certificate: 'Add a certificate',
    insert_certification: 'Add a certification',
    spoken_languages: 'Spoken languages',
    add_your_cv: 'Add your new CV',
    cv_uploaded: 'CVs uploaded',
    select_language: 'Select a language',
    update_user_message: 'Profile updated successfully!',
    profile: 'Profile',
    account_setting: 'Account',
    add_video_cv: 'Add your video CV',
    upload_video: 'Upload video',
    add_link_video: 'Or insert video CV link',
    view_all_text_privacy: 'View full text',
    open_to_work: 'Open to work',
    by_setting_the_mode_on:
        'By setting the mode ON, you gain access to job search features. Other users will not know you are Open to work',
    profile_settings: {
        in_remote: 'Remote',
        offerts_distance: 'Maximum offer distance',
        phone_number: 'Phone number',
        connected_accounts: 'Connected accounts',
        other_settings: 'Other settings',
        show_opportunities: 'Show me opportunities',
        app_languages: 'Application language',
        others_cities_and_nations: 'Additional cities and countries',
        notification_preference: 'Notification preferences',
        privacy: 'Privacy',
        cookie_policy: 'Cookie Policy',
        privacy_policy: 'Privacy Policy',
        terms_and_conditions: 'Terms and conditions',
        legal_notes: 'Legal notes',
        delete_account: 'Delete account',
    },
};

export default en;
